// extracted by mini-css-extract-plugin
export default {"text":"TutorialTip_text__iQP05","skip":"TutorialTip_skip__9Ir0W","buttons":"TutorialTip_buttons__TIp+X","spaced":"TutorialTip_spaced__PnkHb","end":"TutorialTip_end__tbgaV"};